exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box-img[data-v-7b147fd6]{border-radius:9px;width:100%}", ""]);

// exports
